import React, { useState, useEffect, useRef } from "react";
import Modal from "../components/Modal.jsx";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "../styles/components/header.css";
import Logo from "../assets/icons/logo.svg";
import MenuIcon from "../assets/icons/menu-icon.svg";
import CloseIcon from "../assets/icons/close-icon.svg";
import LogoutIcon from "../assets/icons/logout-icon.svg";


const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1170);
  const headerRef = useRef(null);

  const navigate = useNavigate();


  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    localStorage.removeItem("accessToken");
    setShowLogoutModal(false);
    navigate("/");
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1170);
      if (window.innerWidth > 1170) {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!headerRef.current) return;
      if (!headerRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);


  return (
    <>
      <div className={`overlay ${isMenuOpen ? "visible" : ""}`} onClick={() => setIsMenuOpen(false)}></div>
      <motion.header className="header" ref={headerRef} transition={{ layout: { duration: 0.25 } }}>
        <div className="header-container">
          <div className="header-logo">
            <img src={Logo} alt="Bishkek Petroleum" />
          </div>
          <button className="menu-toggle-button" onClick={toggleMenu}>
            <img src={isMenuOpen ? CloseIcon : MenuIcon} alt="Menu Toggle" />
          </button>
          {isMobile ? (
            <AnimatePresence>
              {isMenuOpen && (
                <motion.nav className="header-nav" initial={{ opacity: 0, y: 0 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 0 }} transition={{ duration: 0.25 }}>
                  <div className="nav-item">
                    <Link to="/news" className="nav-btn" onClick={handleLinkClick}>Новости</Link>
                  </div>
                  <div className="nav-item">
                    <Link to="/promotions" className="nav-btn" onClick={handleLinkClick}>Акции</Link>
                  </div>
                  <div className="nav-item">
                    <Link to="/vacancies" className="nav-btn" onClick={handleLinkClick}>Вакансии</Link>
                  </div>
                  <div className="nav-item">
                    <Link to="/stations" className="nav-btn" onClick={handleLinkClick}>АЗС</Link>
                  </div>
                  <div className="nav-item">
                    <Link to="/gallery" className="nav-btn" onClick={handleLinkClick}>Галерея</Link>
                  </div>
                  <div className="nav-item">
                    <Link to="/usefull_info" className="nav-btn" onClick={handleLinkClick}>Полезная информация</Link>
                  </div>
                  <div className="nav-item">
                    <Link to="/social_activities" className="nav-btn" onClick={handleLinkClick}>Соц. деятельность</Link>
                  </div>
                  <div className="nav-item">
                    <Link to="/state_procurement" className="nav-btn" onClick={handleLinkClick}>Гос. закупки</Link>
                  </div>
                  <div className="nav-item">
                    <Link to="/fuel_prices" className="nav-btn" onClick={handleLinkClick}>Цены ГСМ</Link>
                  </div>
                  <div className="nav-item">
                    <button className="logout-btn" onClick={handleLogout}>
                      <img src={LogoutIcon} alt="Logout" className="logout-icon" />
                      Выход
                    </button>
                  </div>
                </motion.nav>
              )}
            </AnimatePresence>
          ) : (
            <nav className={`header-nav ${isMenuOpen ? "open" : ""}`}>
              <div className="nav-item">
                <Link to="/news" className="nav-btn" onClick={handleLinkClick}>Новости</Link>
              </div>
              <div className="nav-item">
                <Link to="/promotions" className="nav-btn" onClick={handleLinkClick}>Акции</Link>
              </div>
              <div className="nav-item">
                <Link to="/vacancies" className="nav-btn" onClick={handleLinkClick}>Вакансии</Link>
              </div>
              <div className="nav-item">
                <Link to="/stations" className="nav-btn" onClick={handleLinkClick}>АЗС</Link>
              </div>
              <div className="nav-item">
                <Link to="/gallery" className="nav-btn" onClick={handleLinkClick}>Галерея</Link>
              </div>
              <div className="nav-item">
                <Link to="/usefull_info" className="nav-btn" onClick={handleLinkClick}>Полезная информация</Link>
              </div>
              <div className="nav-item">
                <Link to="/social_activities" className="nav-btn" onClick={handleLinkClick}>Соц. деятельность</Link>
              </div>
              <div className="nav-item">
                <Link to="/state_procurement" className="nav-btn" onClick={handleLinkClick}>Гос. закупки</Link>
              </div>
              <div className="nav-item">
                <Link to="/fuel_prices" className="nav-btn" onClick={handleLinkClick}>Цены ГСМ</Link>
              </div>
              <div className="nav-item">
                <button className="logout-btn" onClick={handleLogout}>
                  <img src={LogoutIcon} alt="Logout" className="logout-icon" />
                </button>
              </div>
            </nav>
          )}
        </div>
      </motion.header>
      {showLogoutModal && (
        <Modal
          isOpen={showLogoutModal}
          message="Вы действительно хотите выйти?"
          onCancel={cancelLogout}
          onConfirm={confirmLogout}
        />
      )}
    </>
  );
};
export default Header;
